import round from 'lodash/round';

import { doRequest } from '@r1-frontend/do-request';
import { current } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/current';
import { TResponseDto } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/current/dto/ResponseDto';

import { initialization as initializationAction, setCurrentTariff } from '~/src/features/tariffBuilder/actions';
import { recalculate } from '~/src/features/tariffBuilder/actions/thunk';
import { TCtxDispatch } from '~/src/features/tariffBuilder/Ctx';
import { TLimitations } from '~/src/features/tariffBuilder/types/TLimitations';

const initialization = (routerLimits: TLimitations, decoderLimits: TLimitations, withCurrent?: boolean) => async(dispatch: TCtxDispatch) => {
    dispatch(initializationAction(routerLimits, decoderLimits));

    if (withCurrent) {
        const response = await doRequest.apiTariffs<TResponseDto>(current());

        if (response.isSuccess) {
            dispatch(setCurrentTariff({ ...response.payload, speed: round(response.payload.speed, -2) }));
        }
    }

    dispatch(recalculate());
};

export default initialization;
